import store from '@/store';

import { prepareResponse } from './utils.js';
const development = process.env.NODE_ENV === 'development';
const staging = process.env.NODE_ENV === 'staging';
const production = process.env.NODE_ENV === 'production';

/**
* business ID to use for the Resources API
* have overide in resources.vue
*/
export const resourcesBusinessId = store.getters.getActiveAccount.business_id ? store.getters.getActiveAccount.business_id : 1;

export default {
  resourcesBusinessId,
  urls: {
    approvals: (function () {
      if (production) {
        return 'https://approval.api.unoapp.io'
      } else if (staging) {
        return 'https://approval.beta.api.unoapp.io'
      } else if (development) {
        return 'https://approval.dev.api.unoapp.io'
      }
    })(),
    loyalty: (function () {
      if (production) {
        return 'https://loyalty.api.unoapp.io'
      } else if (staging) {
        return 'https://loyalty.beta.api.unoapp.io'
      } else if (development) {
        return 'https://loyalty.dev.api.unoapp.io'
      }
    })(),
    ecomm: (function () {
      if (production) {
        return 'https://freshii.api.unoapp.io/api'
      } else if (staging) {
        return 'https://freshii.beta.api.unoapp.io/api'
      } else if (development) {
        return 'http://dev.api.unoapp.io/freshii/api'
      }
    })(),
    resources: (function () {
      if (production) {
        return 'https://resources.beta.api.unoapp.io'
      } else if (staging) {
        return 'https://resources.dev.api.unoapp.io'
      } else if (development) {
        return 'https://resources.dev.api.unoapp.io'
      }
    })()
  },
  headers: function () {
    return {
      approvals: (function () {
        if (production) {
          return {
            appId: '3jJIMoDLAJW2qzQk0DmFCVxhbRzVIL4Qn',
            appSecret: 'cgLb2aWAyY1k3TBmquEjjbOjWxZRc6iw2'
          }
        } else if (staging) {
          return {
            appId: '46c9485f92a0f8ac29d66570893a3805',
            appSecret: '0276a6fd79282e1b73cdd209540cdfcd'
          }
        } else if (development) {
          return {
            appId: '46c9485f92a0f8ac29d66570893a3805',
            appSecret: '0276a6fd79282e1b73cdd209540cdfcd'
          }
        }
      })(),
      loyalty: (function () {
        if (production) {
          return {
            appId: 'KWpZuK0lscFrJ84dkUGsMQVQGDHAtAHv',
            appSecret: 'QVDvjk0cn4jltPnNEQi2hwQlD17pU0dr'
          }
        } else if (staging) {
          return {
            appId: '0CA0D7Lk9D6jZvgeklHiBTX99PYbTDIs',
            appSecret: 'JnJqjxCKnVpvgO5cWGWSkfesTQWaiP46'
          }
        } else if (development) {
          return {
            appId: '0CA0D7Lk9D6jZvgeklHiBTX99PYbTDIs',
            appSecret: 'JnJqjxCKnVpvgO5cWGWSkfesTQWaiP46'
          }
        }
      })(),
      resources: (function () {
        return {
          appId: '3a11172c747ac1fc3bec38b457152446', //tore.getters.appId,
          appSecret: '31ab52949ffdd295caadb8259533572b', //store.getters.appSecret
        }
      })(),
      ecomm: (function () {
        return {
          appId: '3a11172c747ac1fc3bec38b457152446',//store.getters.appId,
          appSecret: '31ab52949ffdd295caadb8259533572b', //store.getters.appSecret
        }
      })()
    }
  },
  /**
   * app_id for the Approvals API
   */
  approvalsAppId: (function () {
    if (production) {
      return '5b60a158baf2d10681b79cd1'
    } else if (staging) {
      return '5b291f11dc35e663e8847981'
    } else if (development) {
      return '5b291f11dc35e663e8847981'
    }
  })(),
  /**
   * base url for API calls to send Messages
   */
  messageBaseUrl: (function () {
    if (production) {
      return 'https://notifications.api.unoapp.io'
    } else if (staging) {
      return 'https://notifications.beta.api.unoapp.io'
    } else if (development) {
      return 'https://notifications.dev.api.unoapp.io'
    }
  })(),
  /**
   * app token for API calls to send Messages
   */
  messageAppToken: (function () {
    if (production) {
      return ''
    } else if (staging) {
      return 'bearer e3e7f5af3c458aa04b3722dc77c4020a'
    } else if (development) {
      return 'bearer bed62ee5c3cc97a2d5297f973af1c15e'
    }
  })(),
  /**
   * app token for API calls to send Messages to OMA users
   */
  OMAUsersMessageAppToken: (function () {
    if (production) {
      return ''
    } else if (staging) {
      return 'bearer 39d270dc380d5ac331f0affc7a4ddb59'
    } else if (development) {
      return 'bearer 6b1642515315f527604919b430fe79de'
    }
  })(),
  /**
   * API key for Google Maps Javascript API
   */
  googleMapsJavascriptApiKey: 'AIzaSyAweYWedKzekUFGNFf-Qb1Ox7ce6Pul2xQ', // aleks@unoapp.com
  /**
   * Ajax wrapper for making backend calls.
   * @function
   * @param {object} options - Options for the ajax call being made.
   * @param {string} api - The api to call
   * @returns {undefined}
   */
  $ajax: function (options, api = 'ecomm') {
  
    let headers = this.headers()
    headers = {
      'app-id': headers[api].appId,
      'app-secret': headers[api].appSecret,
      'auth-token': store.getters.getToken
    }

    headers['Access-Control-Allow-Origin']  = '*';

  
    if (!options.formData) {
      headers['Content-Type'] = 'application/json'
    }

    const routePath = options.url
    const fetchUrl = new URL(this.urls[api] + routePath)
    const fetchOptions = {
      method: options.method,
      headers: new Headers(headers)
    }

    const method = options.method.toLowerCase()
    if (
      options.formData !== true &&
      (
        method === 'post' ||
        method === 'put' ||
        method === 'patch' ||
        method === 'delete'
      )
    ) {
      fetchOptions.body = JSON.stringify(options.body)
    } else {
      fetchOptions.body = options.body
    }

    if (options.method.toLowerCase() === 'get' && options.params !== undefined) {
      Object.keys(options.params).forEach(key => fetchUrl.searchParams.append(key, options.params[key]))
    }

    // console.log({ fetchUrl })
    fetch(fetchUrl, fetchOptions)
      .then(response => response.json())
      .then(response => prepareResponse({
        response,
        api,
        routePath,
        options
      }))
      .then(response => {
        // console.log({ response })
        if (
          response.status === 'ok' ||
          response.status === 'success'
        ) {
          options.success(response)
        } else {
          options.error(response)
        }
      })
      .catch(error => {
        if (staging || development) {
          console.log({ error })
        }
      })
  }
}
